import { render, staticRenderFns } from "./VilleroyBochLogo.vue?vue&type=template&id=437ed4d3&scoped=true&"
var script = {}
import style0 from "./VilleroyBochLogo.vue?vue&type=style&index=0&id=437ed4d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437ed4d3",
  null
  
)

export default component.exports